import Vue from 'vue'

export const state = {
  trackedVehicles: {},
  trackedVehicleCount: 0
}

export const getters = {
  /**
   * Returns the full state object
   *
   * @param state Object
   *
   * @return Object
   */
  get (state) {
    return state
  },

  /**
   * Returns vehicles that are being tracked.
   *
   * @param state Object
   *
   * @return Object
   */
  trackedVehicles (state) {
    return state.trackedVehicles
  },

  /**
   * Returns the number of vehicles being tracked.
   *
   * @param state Object
   *
   * @return Integer
   */
  trackedVehicleCount (state) {
    return state.trackedVehicleCount
  }
}

export const actions = {
}

export const mutations = {
  /**
   * Add a map or array of object vehicles that must be tracked.
   *
   * @param state  Object
   * @param vehicles Array|Map
   */
  addTrackedVehicles (state, vehicles) {
    vehicles.forEach(vehicle => {
      Vue.set(state.trackedVehicles, vehicle.id, vehicle)
    })

    state.trackedVehicleCount = Object.keys(state.trackedVehicles).length
  },

  /**
   * Removes an array of vehicles that should no longer be tracked.
   * The array must consist of the id's of the vehicles that no longer
   * requires tracking.
   *
   * @param state  Object
   * @param vehicles Array
   */
  removeTrackedVehicles (state, vehicles) {
    vehicles.forEach(vehicleId => {
      Vue.delete(state.trackedVehicles, vehicleId)
    })
    state.trackedVehicleCount = Object.keys(state.trackedVehicles).length
  },

  /**
   * Removes all vehicles from being tracked.
   *
   * @param state  Object
   */
  clearTrackedVehicles (state) {
    state.trackedVehicles = {}
    state.trackedVehicleCount = 0
  },

  /**
   * Clears all vehicles from being tracked.
   *
   * @param state Object
   */
  purge (state) {
    state.trackedVehicles = {}
    state.trackedVehicleCount = 0
  },

  /**
   * Sets the telemetry data for the specified vehicle.
   *
   * @param state Object
   * @param vehicleId int
   * @param telemetry Object
   */
  setTelemetry (state, { vehicleId, telemetry }) {
    if (state.trackedVehicles.hasOwnProperty(vehicleId)) {
      Vue.set(state.trackedVehicles[vehicleId], 'telemetry', telemetry)
    }
  },

  /**
   * Sets the analog input configuration for the specified vehicle.
   *
   * @param state Object
   * @param vehicleId int
   * @param analogInputConfig Object
   */
  setAnalogInputCfg (state, { vehicleId, analogInputConfig }) {
    if (state.trackedVehicles.hasOwnProperty(vehicleId)) {
      Vue.set(state.trackedVehicles[vehicleId], 'an_inputs', analogInputConfig)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/assets/vehicles/trackedVehiclesModule.js